import { render, staticRenderFns } from "./drawlotterycard.vue?vue&type=template&id=cc7ac23a&scoped=true"
import script from "./drawlotterycard.vue?vue&type=script&lang=js"
export * from "./drawlotterycard.vue?vue&type=script&lang=js"
import style0 from "./drawlotterycard.vue?vue&type=style&index=0&id=cc7ac23a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc7ac23a",
  null
  
)

export default component.exports